import { Arquivo } from './arquivo';

export class Licitacao {
    id: number;
    numeroDaLicitacao: string;
    modalidade: string;
    comissao: string;
    orgao: string;
    objetoDaLicitacao: string;
    dataDeRealizacao: Date;
    dataDeCadastro: Date;
    faseDaLicitacao: string;
    tipoDeObjetoDaLicitacao: string;
    arquivos: Arquivo[];
    valorLicitacao: string;
    valorEstimadoLicitacao: string;
    vencedorLicitacao: string;
    numeroProcesso: string;
    primeiroAditivo: string;
    segundoAditivo: string;
    identificador: string;
    numeroContrato: string;
    isCovid19: boolean;
}



// WEBPACK FOOTER //
// ./src/app/_classes/licitacao.ts